import React, { useContext, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import {
  Col, Container, Row, Form, Input, Label,
  Card, CardBody, Button, FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import Select from "react-select"
import { useFormik } from "formik"
import { classApi } from "apis/ClassListApi"
import Swal from "sweetalert2"
import { CircularApi } from "apis/CircularAPI"
import { SessionContext } from "context/sessionContext"
import Loading from "components/Loading"
import { classGroupApi } from "apis/ClassGroupApi"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"

const CreateCircular = props => {
  document.title = "Create Circular"
  const [user] = useState(JSON.parse(localStorage.getItem("User")))
  const [classList, setClassList] = useState([])
  const [loading, setloading] = useState(false)
  const [AllClassGroup, setAllClassGroup] = useState([])
  const [selectedFiles, setSelectedFiles] = useState([])
  const [fileError, setFileError] = useState("")
  const { Session } = useContext(SessionContext)
  let session = Session || sessionStorage.getItem("SessionId")

  useEffect(() => {
    classApi.getAllClass()
      .then(res => setClassList(res.data.section_list))
      .catch(err => console.log(err))

    classGroupApi.getClassGroup().then(res => {
      const groups =
        res.data &&
        res.data.grupofclass &&
        res.data.grupofclass.map(g => ({
          value: g.id,
          label: g.group_name,
          st_class: g.st_class,
        }))
      setAllClassGroup(groups || [])
    })
  }, [])

  const classListOption = classList
    ? classList.map(cl => ({
        value: cl.UID,
        label: `${cl.st_class} ${cl.st_sec}`,
      }))
    : []

  const SendListOption = [
    { value: 1, label: "Teacher" },
    { value: 2, label: "Student" },
    { value: 3, label: "Parent" },
  ]

  const MAX_FILE_SIZE = 5 * 1024 * 1024
  const MAX_FILES_COUNT = 5

  const validation = useFormik({
    enableReinitialize: false,
    initialValues: {
      title: "",
      description: "",
      st_class: [],
      send_by: [],
      notice_file: "",
      circular_end_date: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Please Enter Your Title"),
      st_class: Yup.array().min(1, "This is required"),
      send_by: Yup.array().min(1, "This is required"),
    }),
    onSubmit: values => {
      setloading(true)
      const data = new FormData()
      if (selectedFiles && selectedFiles.length > 0) {
        selectedFiles.forEach((file, index) => {
          data.append(`notice_file_${index + 1}`, file)
        })
      }
      data.append("title", values.title)
      data.append("description", values.description)

      if (user === "Admin") {
        data.append("groupofclass_ids", JSON.stringify(values.st_class || []))
        const classes = []
        ;(values.st_class || []).forEach(groupId => {
          const group = AllClassGroup.find(g => g.value === groupId)
          if (group && group.st_class) {
            try {
              JSON.parse(group.st_class).forEach(c => classes.push(c))
            } catch (e) {}
          }
        })
        data.append("st_class", JSON.stringify(classes))
      } else {
        data.append("st_class", JSON.stringify(values.st_class))
      }

      data.append("send_by", JSON.stringify(values.send_by))
      const currentSession = Session || sessionStorage.getItem("SessionId") || session
      data.append("session_id", currentSession)
      if (values.circular_end_date) {
        data.append("circular_end_date", values.circular_end_date)
      }

      CircularApi.createCircular(data)
        .then(res => {
          setloading(false)
          if (res.data.status === 200) {
            Swal.fire({ text: res.data.msg, icon: "success" }).then(result => {
              if (result.isConfirmed) window.location.href = "/circular"
            })
          }
          if (res.data.status === 403) {
            Swal.fire({ text: res.data.msg, icon: "warning" }).then(result => {
              if (result.isConfirmed) window.location.href = "/circular"
            })
          }
        })
        .catch(err => console.log(err))
    },
  })

  // ✅ FIX 1: classhandleChange updates Formik, not local state
  const classhandleChange = selectedOption => {
    if (user === "Admin") {
      const ids = selectedOption ? selectedOption.map(opt => opt.value) : []
      validation.setFieldValue("st_class", ids)
    } else {
      const values = selectedOption || []
      validation.setFieldValue("st_class", values)
    }
    validation.setFieldTouched("st_class", true, false)
  }

  // ✅ FIX 2: send_by handler also marks touched
  const handleChange = selectedOption => {
    validation.setFieldValue("send_by", selectedOption || [])
    validation.setFieldTouched("send_by", true, false)
  }

  const handleFileChange = e => {
    setFileError("")
    const incomingFiles = Array.from(e.target.files || [])
    if (incomingFiles.length === 0) return

    if (selectedFiles.length + incomingFiles.length > MAX_FILES_COUNT) {
      setFileError(
        `You can upload a maximum of ${MAX_FILES_COUNT} PDFs. (${selectedFiles.length} already selected)`
      )
      e.target.value = ""
      return
    }

    const newFiles = []
    for (const file of incomingFiles) {
      if (file.size > MAX_FILE_SIZE) {
        setFileError(`"${file.name}" exceeds the 5 MB limit.`)
        e.target.value = ""
        return
      }
      const duplicate = selectedFiles.some(
        f => f.name === file.name && f.size === file.size
      )
      if (!duplicate) {
        newFiles.push(file)
      }
    }

    const updated = [...selectedFiles, ...newFiles]
    setSelectedFiles(updated)
    validation.setFieldValue("notice_file", updated[0] || "")
    e.target.value = ""
  }

  const handleRemoveFile = index => {
    const updated = selectedFiles.filter((_, idx) => idx !== index)
    setSelectedFiles(updated)
    validation.setFieldValue("notice_file", updated[0] || "")
    setFileError("")
  }

  return (
    <React.Fragment>
      <style>{`
        /* Make disabled / previous-month dates more visible in flatpickr */
        .flatpickr-day.flatpickr-disabled,
        .flatpickr-day.flatpickr-disabled:hover,
        .flatpickr-day.prevMonthDay,
        .flatpickr-day.nextMonthDay {
          color: #74788d !important;
          opacity: 0.85 !important;
        }
      `}</style>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Circular" breadcrumbItem="Create Circular" />
          <Row>
            <Col lg="12">
              <Card className="mb-5">
                {loading ? (
                  <Loading />
                ) : (
                  <CardBody>
                    <Form onSubmit={e => { e.preventDefault(); validation.handleSubmit() }}>
                      <Row>
                        <Col sm={12} lg={6}>

                          {/* Title */}
                          <div className="mb-2">
                            <Label htmlFor="title" className="my-control">Title</Label>
                            <Input
                              id="n_title"
                              name="title"
                              type="text"
                              className="form-control"
                              placeholder="Title"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.title}
                              invalid={validation.touched.title && !!validation.errors.title}
                            />
                            {validation.touched.title && validation.errors.title && (
                              <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
                            )}
                          </div>

                          {/* Class / Class Group */}
                          <div className="mb-3">
                            {user === "Admin" ? (
                              <>
                                <Label className="control-label my-control">Class Group</Label>
                                <Select
                                  name="st_class"
                                  classNamePrefix="select2-selection"
                                  placeholder="Select Class Group..."
                                  options={AllClassGroup}
                                  isMulti
                                  // ✅ FIX 3: value derived from Formik state, not local state
                                 value={AllClassGroup.filter(opt =>
  Array.isArray(validation.values.st_class) &&
  validation.values.st_class.includes(opt.value)
)}
                                  onChange={classhandleChange}
                                  onBlur={() => validation.setFieldTouched("st_class", true)}
                                />
                              </>
                            ) : (
                              <>
                                <Label className="control-label my-control">Class</Label>
                                <Select
                                  name="st_class"
                                  classNamePrefix="select2-selection"
                                  placeholder="Select Class..."
                                  options={classListOption}
                                  isMulti
                                  // ✅ FIX 3: value derived from Formik state
                                  value={validation.values.st_class}
                                  onChange={classhandleChange}
                                  onBlur={() => validation.setFieldTouched("st_class", true)}
                                />
                              </>
                            )}
                            {validation.touched.st_class && validation.errors.st_class && (
                              <div style={{ color: "#f46a6a", fontSize: "11px", marginTop: "3px" }}>
                                This is required
                              </div>
                            )}
                          </div>

                          {/* Send By */}
                          <div className="mb-3">
                            <Label className="control-label my-control">To send</Label>
                            <Select
                              name="send_by"
                              classNamePrefix="select2-selection"
                              placeholder="Select..."
                              options={SendListOption}
                              isMulti
                              // ✅ FIX 3: value derived from Formik state
                              value={validation.values.send_by}
                              onChange={handleChange}
                              onBlur={() => validation.setFieldTouched("send_by", true)}
                            />
                            {validation.touched.send_by && validation.errors.send_by && (
                              <div style={{ color: "#f46a6a", fontSize: "11px", marginTop: "3px" }}>
                                This is required
                              </div>
                            )}
                          </div>

                          {/* Expiry Date */}
                          <div className="mb-3">
                            <Label className="form-label">Expiry Date</Label>
                            <Flatpickr
                              className="form-control"
                              placeholder="Select expiry date"
                              value={validation.values.circular_end_date}
                              options={{
                                dateFormat: "Y-m-d",
                                altInput: true,
                                altFormat: "d M Y",
                                minDate: "today",
                              }}
                              onChange={([date]) => {
                                if (date) {
                                  // Format using local date parts to avoid UTC
                                  // shifting the day back (e.g. selecting the 31st
                                  // becoming the 30th in IST).
                                  const yyyy = date.getFullYear()
                                  const mm = String(date.getMonth() + 1).padStart(2, "0")
                                  const dd = String(date.getDate()).padStart(2, "0")
                                  const formatted = `${yyyy}-${mm}-${dd}`
                                  validation.setFieldValue("circular_end_date", formatted)
                                }
                              }}
                            />
                          </div>

                        </Col>
                        <Col sm={12} lg={6}>

                          {/* Description */}
                          <div className="mb-3">
                            <Label htmlFor="Description">Description</Label>
                            <Input
                              id="n_description"
                              name="description"
                              rows="5"
                              type="textarea"
                              className="form-control"
                              placeholder="Write here your Description"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.description}
                              invalid={validation.touched.description && !!validation.errors.description}
                            />
                            {validation.touched.description && validation.errors.description && (
                              <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                            )}
                          </div>

                          {/* File Upload (Up to 5 Files) */}
                          <div className="mt-0">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                              <Label className="control-label mb-0" htmlFor="circular-files">
                                Upload Documents / PDFs (Up to 5)
                              </Label>
                              <span className="badge bg-light text-primary font-size-11">
                                {selectedFiles.length} / {MAX_FILES_COUNT} selected
                              </span>
                            </div>
                            <div className="input-group">
                              <Input
                                name="notice_file"
                                type="file"
                                multiple
                                accept=".pdf,application/pdf,image/png,image/jpeg,image/jpg"
                                className="form-control"
                                id="circular-files"
                                disabled={selectedFiles.length >= MAX_FILES_COUNT}
                                onChange={handleFileChange}
                              />
                            </div>
                            <small className="text-muted d-block mt-1">
                              Upload up to 5 attachments (PDF, PNG, JPG - Max 5MB each)
                            </small>
                            {fileError && (
                              <div style={{ color: "red", fontSize: "11px", marginTop: "3px" }}>
                                <i className="mdi mdi-alert-circle-outline me-1" />
                                {fileError}
                              </div>
                            )}

                            {selectedFiles.length > 0 && (
                              <div className="mt-2 border rounded p-2 bg-light">
                                <div className="font-size-12 fw-bold text-muted mb-2">
                                  Selected Files ({selectedFiles.length}):
                                </div>
                                <div className="d-flex flex-column gap-1">
                                  {selectedFiles.map((file, idx) => {
                                    const isPdf =
                                      file.type === "application/pdf" ||
                                      file.name.toLowerCase().endsWith(".pdf")
                                    const sizeKb = (file.size / 1024).toFixed(1)
                                    const sizeMb = (file.size / (1024 * 1024)).toFixed(2)
                                    const sizeText =
                                      file.size > 1024 * 1024 ? `${sizeMb} MB` : `${sizeKb} KB`

                                    return (
                                      <div
                                        key={idx}
                                        className="d-flex align-items-center justify-content-between bg-white px-2 py-1 rounded border border-light"
                                      >
                                        <div className="d-flex align-items-center text-truncate me-2">
                                          {isPdf ? (
                                            <i className="mdi mdi-file-pdf-outline text-danger font-size-20 me-2" />
                                          ) : (
                                            <i className="mdi mdi-file-image-outline text-success font-size-20 me-2" />
                                          )}
                                          <span
                                            className="text-truncate font-size-12"
                                            title={file.name}
                                          >
                                            {file.name}
                                          </span>
                                          <span className="text-muted font-size-11 ms-2">
                                            ({sizeText})
                                          </span>
                                        </div>
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-link text-danger p-0"
                                          onClick={() => handleRemoveFile(idx)}
                                          title="Remove file"
                                        >
                                          <i className="mdi mdi-trash-can-outline font-size-16" />
                                        </button>
                                      </div>
                                    )
                                  })}
                                </div>
                              </div>
                            )}
                          </div>

                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col sm={12} className="d-flex align-items-end justify-content-end gap-2">
                          <Link to="/circular" className="btn btn-secondary waves-effect">
                            Back
                          </Link>
                          <Button color="primary" type="submit"
                            className="btn btn-primary waves-effect waves-light">
                            Submit
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                )}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CreateCircular